import { takeEvery, fork, put, all, call } from "redux-saga/effects"
import {
  addEmployeeAPI,
  getEmployeeAPI,
  deleteEmployeeAPI,
  editEmployeeAPI,
  verifyEmpOTPAPI,
  getEmployeeProfileApi,
viewEmployeeAPI,
MYEmployeeAPI,
transferEmpAssetsAPI
} from "./api"
import {
  addEmployeeSuccess,
  addEmployeeFailure,
  getEmployeesSuccess,
  getEmployeesFailure,
  deleteEmployeeSuccess,
  deleteEmployeeFailure,
  editEmployeeSuccess,
  editEmployeeError,
  verifyEmployeeSuccess,
  verifyEmployeeFailure,
  getEmpProfileSuccess,
  getEmpProfileFailure,
  viewEmployeesSuccess,
  viewEmployeesFailure,
  myEmployeeSuccess,
  myEmployeeFailure,
  transferEmpAssetsSuccess,
  transferEmpAssetsFailed,
} from "./action"
import {
  ADD_EMPLOYEE_START,
  GET_EMPLOYEE_START,
  DELETE_EMPLOYEE_START,
  EDIT_EMPLOYEE_START,
  VERIFY_EMPLOYEE_START,
  GET_EMPLOYEE_PROFILE_START,
  VIEW_EMPLOYEE_START,
  MY_EMPLOYEE_START,
  TRANSFER_EMP_ASSETS,
} from "./actiontype"

function* addEmployeeAsync(action) {
  try {
    const response = yield call(addEmployeeAPI, action.payload)
    if (response.status === 200) {
      yield put(addEmployeeSuccess(response.data))
    } 
    else {
      console.log(response.data)
      yield put(addEmployeeFailure(response.data))
    }
   
  } catch (error) {
   
    yield put(addEmployeeFailure(error.response.data))
  }
}
function* AddEmployee() {
  yield takeEvery(ADD_EMPLOYEE_START, addEmployeeAsync)
}

function* getEmployeeAsync(action) {
  try {
    const response = yield call(getEmployeeAPI, action.payload)
    if (response.status === 200) {
      yield put(getEmployeesSuccess(response.data))
    } else {
      throw new Error(Response)
    }
  } catch (error) {
    yield put(getEmployeesFailure(error.response.data))
  }
}

function* GetEmployee() {
  yield takeEvery(GET_EMPLOYEE_START, getEmployeeAsync)
}

function* deleteEmployeeAsync(action) {
  try {
    const response = yield call(deleteEmployeeAPI, action)
    if (response.status === 200) {
      yield put(deleteEmployeeSuccess(response.data))
    } else {
      throw new Error(Response)
    }
  } catch (error) {
    yield put(deleteEmployeeFailure(error.response.data))
  }
}

function* DeleteEmployee() {
  yield takeEvery(DELETE_EMPLOYEE_START, deleteEmployeeAsync)
}

function* editEmployeeAsync(action) {
  try {
    const response = yield call(editEmployeeAPI, action.payload)
    if (response.status === 200) {
      yield put(editEmployeeSuccess(response.data))
    } else {
      throw response
    }
  } catch (error) {
    yield put(editEmployeeError(error.response.data || "Something Error Occured"))
  }
}
function* editEmployee() {
  yield takeEvery(EDIT_EMPLOYEE_START, editEmployeeAsync)
}

// for employee verify

function* verifyEmpAsync(payload) {
  try {
    console.log("Trying to varifying OTP (within try block)")
    const response = yield call(verifyEmpOTPAPI, payload)
    if (response.status === 200) {
      yield put(verifyEmployeeSuccess(response.data))
    } else {
      console.log("Error occured")
      throw new Error(response)
    }
  } catch (error) {
    yield put(verifyEmployeeFailure(error.response.data))
  }
}
export function* VerifyEmp() {
  yield takeEvery(VERIFY_EMPLOYEE_START, verifyEmpAsync)
}

function* getEmployeeProfileAsync(action) {
  try {
    const response = yield call(getEmployeeProfileApi, action.payload)
    if (response.status === 200) {
      localStorage.setItem('type', response.data.premium_type)

      yield put(getEmpProfileSuccess(response.data))
    } else {
      throw new Error(Response)
    }
  } catch (error) {
    yield put(getEmpProfileFailure(error.response.data))
  }
}

function* GetEmployeeProfile() {
  yield takeEvery(GET_EMPLOYEE_PROFILE_START, getEmployeeProfileAsync)
}

function* SingleviewEmployeeAsync(action) {
  try {
    const response = yield call(viewEmployeeAPI, action.payload)
    if (response.status === 200) {
      yield put(viewEmployeesSuccess(response.data))
    } else {
      throw new Error(Response)
    }
  } catch (error) {
    yield put(viewEmployeesFailure(error.response.data))
  }
}

function* SingleviewEmployee() {
  yield takeEvery(VIEW_EMPLOYEE_START, SingleviewEmployeeAsync)
}


// MY EMPLOYEE OR USER :
function* MyEmployeeAsyncAPI(action) {
  try {
    const response = yield call(MYEmployeeAPI, action)
    if (response.status === 200) {

      yield put(myEmployeeSuccess(response.data.users))
    } else {
      throw new Error(Response)
    }
  } catch (error) {
    yield put(myEmployeeFailure(error.response.data))
  }
}

function* MYEmployee() {
  yield takeEvery(MY_EMPLOYEE_START, MyEmployeeAsyncAPI)
}




// MY EMPLOYEE OR USER :
function* transferEmpAssetsAsync(action) {
  try {
    const response = yield call(transferEmpAssetsAPI, action)
    if (response.status === 200) {

      yield put(transferEmpAssetsSuccess(response?.data?.message|| "Transfer Employee Assests Successfully."))
    } else {
      throw new Error(Response)
    }
  } catch (error) {
    yield put(transferEmpAssetsFailed(error.response.data|| "Something Error Occured, please try again"))
  }
}

function* transferEmpAssets() {
  yield takeEvery(TRANSFER_EMP_ASSETS, transferEmpAssetsAsync)
}

function* EmployeeSaga() {
  yield all([
    fork(AddEmployee),
    fork(GetEmployee),
    fork(DeleteEmployee),
    fork(editEmployee),
    fork(VerifyEmp),
    fork(GetEmployeeProfile),
    fork(SingleviewEmployee),
    fork(MYEmployee),
    fork(transferEmpAssets)
  ])
}
export default EmployeeSaga
